import { InfoContainer } from './base/info-container.component';

export function NotFoundErrorPage() {
  return (
    <InfoContainer
      title="404 - Seite nicht gefunden"
      description="Die Seite, die Sie suchen, konnte nicht gefunden werden."
      button={{
        text: 'Zurück zur Startseite',
        href: '/',
      }}
    />
  );
}
